export default __webpack_public_path__ + "static/logo-88e17230fa06a41d5c3b5f77012175ba.png";